export default class SupplierActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static SUCCESS_DATA='SUCCESS_DATA';
  static GET_HELPER_SUPPLIER='GET_HELPER_SUPPLIER';
  static GET_HELPER_SUPPLIER_FULL='GET_HELPER_SUPPLIER_FULL'
  static RESET_LIST='RESET_LIST'


  static submit(){
    return {
      type: SupplierActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type: SupplierActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type: SupplierActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type: SupplierActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type: SupplierActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type: SupplierActions.SHOW_DATA,
      payload: data
    };
  }
  static error(error){
    return {
      type: SupplierActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type: SupplierActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type: SupplierActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type: SupplierActions.RESET_DATA,
    };
  }
  static resetList(){
    return {
      type: SupplierActions.RESET_LIST,
    };
  }

  static helper(data){
    return {
      type: SupplierActions.GET_HELPER_SUPPLIER,
      payload:data
    };
  }
  static helperFull(data){
    return {
      type: SupplierActions.GET_HELPER_SUPPLIER_FULL,
      payload:data
    };
  }
  static errorInternal(error){
    return {
      type: SupplierActions.ERROR_SERVER,
      payload: error
    };
  }
}

